import { forwardRef } from "react";
import { TWizardStepComponentStatic } from "../../../interfaces";
import { WizardStepWelcomeView } from "../../../Student/Steps/WizardStepWelcome";

export const WizardStepWelcome: TWizardStepComponentStatic<any> = forwardRef(
  () => {
    return <WizardStepWelcomeView userType="host" />;
  }
);
